import { isEqual } from "lodash";
import React from "react";

import { prepareSectionIdList } from "../lib/prepareSectionsList";
import SEOHelper from "../lib/SEOHelper/SEOHelper";
import Loader from "../web/components/common/Loader";

export default function withStockSeoMetadata(WrappedComponent) {
  class WithStockSeoMetadata extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        slugList: [],
        seoData: null,
        seoFetchError: null,
        preparedSlugList: [],
        preparedSectionIdList: []
      };
    }

    async fetchData() {
      const {
        match: {
          params: { marketId, stockId, section }
        },
        locale,
        authToken,
        marketTranslations
      } = this.props;

      try {
        const slugListPromise = SEOHelper.getStockSlugList(
          locale,
          authToken,
          marketId,
          marketTranslations
        );
        const preparedSlugListPromise = SEOHelper.getPreparedSectionSlugList({
          locale,
          authToken,
          marketId,
          marketTranslations
        });

        const [slugList, preparedSlugList] = await Promise.all([
          slugListPromise,
          preparedSlugListPromise
        ]);
        const preparedSectionIdList = prepareSectionIdList(slugList);

        const seoData = await SEOHelper.getStockSeoMetadata(
          locale,
          authToken,
          marketId,
          stockId,
          preparedSectionIdList[section],
          marketTranslations
        );

        this.setState({
          slugList,
          seoData,
          seoFetchError: null,
          preparedSlugList,
          preparedSectionIdList
        });
      } catch (error) {
        this.setState({
          slugList: [],
          seoData: null,
          seoFetchError: error,
          preparedSlugList: [],
          preparedSectionIdList: []
        });
      }
    }

    componentDidMount() {
      void this.fetchData();
    }

    componentDidUpdate(prevProps) {
      const {
        marketTranslations,
        match: {
          params: { marketId, stockId, section }
        }
      } = this.props;

      const {
        marketTranslations: prevMarketTranslations,
        match: {
          params: {
            marketId: prevMarketId,
            stockId: prevStockId,
            section: prevSection
          }
        }
      } = prevProps;

      if (
        !isEqual(marketTranslations, prevMarketTranslations) ||
        marketId !== prevMarketId ||
        stockId !== prevStockId ||
        section !== prevSection
      ) {
        void this.fetchData();
      }
    }

    render() {
      const {
        seoData,
        seoFetchError,
        slugList,
        preparedSlugList,
        preparedSectionIdList
      } = this.state;

      if (seoData === null && !seoFetchError) {
        return <Loader />;
      }

      return (
        <WrappedComponent
          seoData={seoData}
          seoFetchError={seoFetchError}
          preparedSlugList={preparedSlugList}
          preparedSectionIdList={preparedSectionIdList}
          slugList={slugList}
          {...this.props}
        />
      );
    }
  }

  return WithStockSeoMetadata;
}
